






















import { Component, Vue } from 'vue-property-decorator';
import { NewsModule } from '@/store/modules/news/news.store';
import { NewsViewObject } from '@/types/apiServerContract';

@Component
export default class NewsStatistics extends Vue {
    get News(): NewsViewObject[] {
        return NewsModule.news;
    }

    get LatestNews(): NewsViewObject {
        return this.News[0];
    }
}
